export const depositWalletsA = {
  BSC: { BUSD: "0x61d3193433e672df6ea91a77d80c95c9a32b4233" },
};
